import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import { styled, useTheme } from '@mui/material/styles';
import { List, ListSubheader, ListItem, ListItemButton, ListItemIcon, ListItemText, Avatar } from '@mui/material';
import { useSelector } from '../../../../redux/store';
import { MIcon } from '../../../@material-extend';

import { PATH_PAGE } from '../../../../routes/paths';

const SearchBarResultsList = ({
  APPBAR_MOBILE,
  APPBAR_DESKTOP,
  searchResults,
  loading,
  handleClose,
  isOpen,
  searchValue
}) => {
  const navigate = useNavigate();
  const { palette, breakpoints, spacing } = useTheme();
  const { month } = useSelector((state) => state.schedules);

  const MenuStyled = styled(List)({
    position: 'absolute',
    top: APPBAR_MOBILE,
    left: 0,
    width: '100%',
    maxHeight: '50vh',
    overflow: 'auto',
    paddingBottom: '0.8rem !important',
    backgroundColor: palette.background.default,
    [breakpoints.up('md')]: {
      top: APPBAR_DESKTOP,
      padding: spacing(0, 5)
    }
  });

  let subheaderText = `Résultat de votre recherche (${searchResults.length})`;
  if (loading) {
    subheaderText = 'Recherche en cours...';
  } else if (!searchResults.length) {
    subheaderText = 'Aucun résultat';
  }

  const handleClickListItem = (row) => {
    switch (row.type) {
      case 'site':
        navigate(`${PATH_PAGE.general.site.siteSheet}?siteId=${row.id}`);
        break;
      case 'agent':
        navigate(`${PATH_PAGE.general.resource.resourceSheet}?resourceId=${row.id}&month=${month}`);
        break;
      default:
        return;
    }

    handleClose();
  };

  if (!isOpen || !searchValue.length) {
    return;
  }

  return (
    <MenuStyled sx={{ boxShadow: 3 }} subheader={<ListSubheader>{subheaderText}</ListSubheader>}>
      {searchResults.map((row, idx) => {
        const { imageUrl, name, type } = row;
        return (
          <ListItem key={idx} disablePadding>
            <ListItemButton onClick={() => handleClickListItem(row)}>
              <ListItemIcon>
                <Avatar src={imageUrl} alt={name}>
                  <MIcon icon={type === 'agent' ? 'person' : 'site'} filled />
                </Avatar>
              </ListItemIcon>
              <ListItemText primary={name} secondary={type} sx={styleListItemText} />
            </ListItemButton>
          </ListItem>
        );
      })}
    </MenuStyled>
  );
};

const styleListItemText = {
  color: 'text.primary',
  '.MuiListItemText-secondary': {
    textTransform: 'capitalize'
  }
};

SearchBarResultsList.propTypes = {
  APPBAR_MOBILE: PropTypes.number.isRequired,
  APPBAR_DESKTOP: PropTypes.number.isRequired,
  isOpen: PropTypes.bool,
  loading: PropTypes.bool,
  searchResults: PropTypes.array,
  searchValue: PropTypes.string,
  handleClose: PropTypes.func.isRequired
};
export default SearchBarResultsList;
